import { gql } from 'graphql.macro';

export const CreateOpportunity = gql`
    mutation createOpportunity($request: OpportunityRequestModelInput) {
        createOpportunity(request: $request) {observationId, uniqueRecordId}
    }
`;